import React from 'react';

import { useTypedDispatch, useTypedSelector } from '@/store/store';
import {
  getSelectedFilters,
  setCarSeats,
  setPage,
} from '@/store/reducers/cars-stock';
import { RangeType } from '@/typings/common';
import { MobileFilterWrapper } from '@/modules/CarsStock/components/common.styles';
import StockFilterRange from '@/components/StockFilterRange';

function SeatsFilter() {
  const dispatch = useTypedDispatch();
  const selectedSeats =
    useTypedSelector(getSelectedFilters).selectedParams.selectedSeats;

  const handleBlurSeats = (seats: RangeType) => {
    dispatch(setCarSeats(seats));
    dispatch(setPage(1));
  };

  return (
    <MobileFilterWrapper>
      <StockFilterRange
        label="Количество мест"
        values={selectedSeats}
        onBlur={handleBlurSeats}
      />
    </MobileFilterWrapper>
  );
}

export default SeatsFilter;
